export default __webpack_public_path__ + "static/media/star-primary.85b41300.svg";